import type { Node } from "@tiptap/pm/model";

type ExcludedRange = { from: number; to: number };

export function summaryEvidenceExcludedRanges(
  doc: Node,
  { includeRemoved = false }: { includeRemoved?: boolean } = {},
) {
  const ranges: ExcludedRange[] = [];
  let inGlance = false;
  let inRemoved = false;

  doc.forEach((node, pos) => {
    // A section heading ends whichever reviewer-only run was open. The removed block is rendered last
    // today, so nothing follows it — but relying on that would make a later reordering silently stop
    // highlighting every section after it.
    if (node.type.name === "heading" && node.attrs.level === 2) {
      inGlance = node.textContent.startsWith("🔎 At a glance");
      inRemoved = false;
    }
    if (node.type.name === "horizontalRule") inGlance = false;

    // Tiptap unwraps <details>/<summary>, leaving the removed-block label as a paragraph.
    if (node.type.name === "paragraph" && /^🛑 Removed from coding \(\d+\)/.test(node.textContent)) inRemoved = true;

    const nothingRecorded = node.type.name === "paragraph" && node.textContent.startsWith("Nothing recorded:");
    if (inGlance || (inRemoved && !includeRemoved) || nothingRecorded) {
      ranges.push({ from: pos, to: pos + node.nodeSize });
      return;
    }

    if (node.type.name !== "table") return;
    const header = node.firstChild;
    if (!header) return;

    const notesColumns = new Set<number>();
    header.forEach((cell, _offset, index) => {
      if (cell.type.name === "tableHeader" && cell.textContent.trim() === "🤖 AI notes") notesColumns.add(index);
    });

    node.forEach((row, rowOffset) => {
      row.forEach((cell, cellOffset, index) => {
        if (!notesColumns.has(index)) return;
        const from = pos + 2 + rowOffset + cellOffset;
        ranges.push({ from, to: from + cell.nodeSize });
      });
    });
  });

  return ranges;
}
